import colors from 'shared-tokens/utils/tokens/colors';
import createTransition from 'shared-tokens/utils/createTransition';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

import { mainCls as detailsCls } from '../../style';

const brTablet = createBreakpoint('s');

export const mainCls =  `${detailsCls}__contacts`;
export const mapCls =  `map_${detailsCls}__contacts`;

export default {
  [mainCls]: {
    marginTop: 24,
    height: 40,
    [brTablet]: {
      marginTop: 0,
    },
    '& > .grid': {
      height: 40,
    },
  },
  [mapCls]: {
    marginTop: 24,
    height: 40,
    [brTablet]: {
      marginTop: 16,
    },
    '& > .grid': {
      height: 40,
    },
  },  
  [`${mainCls}__agz`]: {
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      [`${mainCls}__agz__name`]: {
        textDecoration: 'underline',
      },
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  
  },
  [`${mainCls}__agz__logo`]: {
    display: 'block',
    height: 28,
    objectFit: 'contain',
    border: '1px solid rgba(26,31,36,.062745098)',

    '&.pm': {
      width: 69,
      height: 34,
    },
  },
  [`${mainCls}__agz__name`]: {
    display: 'none',
    [brTablet]: {
      display: 'block',
    },
  },
  [`${mapCls}__agz__name`]: {
    display: 'none',
  },
  [`${mainCls}__sendmail`]: {
    lineHeight: '20px',
    borderColor: `${colors.f3.rgba} !important`,
    borderRadius: 4,
    [brTablet]: {
      borderColor: `${colors.border.rgba} !important`,
      transition: createTransition(['color', 'background-color', 'border-color']),
      '&:hover': {        
        color: '#FFF !important',
        borderColor: `${colors.secondary.rgba} !important`,
        backgroundColor: `${colors.secondary.rgba} !important`,
      }
    },
  },
  [`${mainCls}__savectn`]: {
    marginLeft: 16,
    [brTablet]: {
      marginLeft: 8,
    },
  },
  [`${mainCls}__save`]: {
    margin: 0,
    padding: 0,
    width: 32,
    height: 32,
    border: '0 none',
    [brTablet]: {
      transition: createTransition(['color']),
      '&:hover': {
        color: `${colors.f0.rgba} !important`,
      }
    },
    '& svg': {
      marginTop: -2,
    }
  },
  [`${mainCls}__pin`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    width: 32,
    height: 32,
    border: 0,
    '@media (hover: hover)': {
      transition: createTransition(['color']),
    }
  },
};
